import {Component, OnDestroy, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import {AuthService} from './services/auth.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/internal/operators/filter';
import {Carousel} from 'primeng/carousel';
import {IntercomService} from './services/intercom.service';
import {ViewportService} from './services/viewport.service';
import {ChurnkeyService} from './services/churnkey.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    private cleanupFns: Array<() => void> = [];
    showFooter = true;

    constructor(private primengConfig: PrimeNGConfig, private authService: AuthService, private router: Router, private intercom: IntercomService, private viewport: ViewportService, private route: ActivatedRoute, private churnkeyService: ChurnkeyService) {
        Carousel.prototype.onTouchMove = () => { };
        this.router.events
            .pipe(filter(evt => evt instanceof NavigationEnd))
            .subscribe(async (evt: NavigationEnd) => {
                this.handleNavigation(evt);
                await this.churnkeyService.loadFailedPaymentWall();
            });
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        // Single-letter weekday headers in every p-calendar (prototype design;
        // the default is two-letter "Su Mo …").
        this.primengConfig.setTranslation({dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']});
        this.applyIntercomLauncherRule();
        this.intercom.initUserIntercom();

        this.initStableViewportHeightVar();

        this.viewport.isMobile$.subscribe(isMobile => {
            if (isMobile) {
                this.viewport.isMobile
            }
        });
    }
    private handleNavigation(evt: NavigationEnd) {
        const tree = this.router.parseUrl(evt.urlAfterRedirects);
        if (tree.fragment) {
            document.documentElement.classList.add('smooth');
            setTimeout(() => {
                const el = document.getElementById(tree.fragment!);
                if (el) {
                    el.scrollIntoView({ block: 'start' });
                }
                setTimeout(() => {
                    document.documentElement.classList.remove('smooth');
                }, 500);
            }, 0);

        } else {
            document.documentElement.classList.remove('smooth');
            window.scrollTo(0, 0);
        }
        let r: ActivatedRoute = this.route;
        while (r.firstChild) r = r.firstChild;

        const hideFooter = r.snapshot.data?.['hideFooter'] === true;
        this.showFooter = !hideFooter;
    }

    private applyIntercomLauncherRule(): void {
        this.intercom.setLauncherVisible(!this.viewport.isMobile);
        if (this.viewport.isMobile) {
            this.intercom.hideMessenger();
        }
    }

    ngOnDestroy(): void {
        this.cleanupFns.forEach(fn => fn());
    }

    private initStableViewportHeightVar(): void {
        const setVh = () => {
            const height = window.innerHeight;
            document.documentElement.style.setProperty('--vvh', `${height * 0.01}px`);
        };

        setVh();

        const onOrientation = () => setTimeout(setVh, 300);
        window.addEventListener('orientationchange', onOrientation);
        this.cleanupFns.push(() => window.removeEventListener('orientationchange', onOrientation));

        const isMobile = this.viewport.isMobile;
        if (!isMobile) {
            const onResize = () => setVh();
            window.addEventListener('resize', onResize);
            this.cleanupFns.push(() => window.removeEventListener('resize', onResize));
        }
    }



}
